// @flow
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import path from 'ramda/es/path';
import prop from 'ramda/es/prop';
import isNil from 'ramda/es/isNil';
import isEmpty from 'ramda/es/isEmpty';
import last from 'ramda/es/last';
import { withTranslation } from 'react-i18next';

import { CAFETERIA_TYPE_GLOLIME } from 'app/constants/apps/cafeteria';
import toFixedValue from 'app/common/lib/toFixedValue';
import isToday from 'app/selectors/isToday';
import { getIsStudent } from 'app/selectors/user';


const mkBalance = (hasCafeteria, loading, val, t) => {
  if (!hasCafeteria || isNil(val) || loading || typeof val !== 'number') {
    return '';
  }
  return t('children:food_balance', { balance: toFixedValue(val) });
};

const mkBalanceCamp = (hasCafeteria, loading, camps, t) => {
  const balance = (
    !camps || isEmpty(camps)
      ? null
      : (path(['balance'], last(camps)) || null)
  );
  if (!hasCafeteria || isEmpty(camps) || loading || balance === null) {
    return '';
  }
  return t('children:food_balance_camp', { balance: toFixedValue(balance) });
};

type Props = {
  id: number,
  shadow: boolean,
  date: string,
  t: (s: string, b: Object) => string,
}

export default compose(
  withTranslation(),

  connect(
    (state, props: Props) => {
      const { id, t } = props;
      const {
        name,
        photo,
        gender,
        status,
        graduated,
        klass,
        school,
        hasCafeteria,
        cafeteriaExternalServiceType,
        personalAccountNumber,
        externalSystemSync,
        camps,
      } = path(['students', 'data', id], state) || {};

      // TODO optimize with reselect
      const loading = (state.cafeteria.costs.loading
        || state.cafeteria.costs.result !== 'success');

      const balance = mkBalance(
        hasCafeteria,
        loading,
        path(['cafeteria', 'costs', 'balance', id], state),
        t
      );

      const balanceCamp = mkBalanceCamp(hasCafeteria, loading, camps, t);

      const isGlolime = cafeteriaExternalServiceType === CAFETERIA_TYPE_GLOLIME;
      const isStudent = getIsStudent(state);

      return ({
        id,
        name: prop('first', name) || '',
        photo,
        gender,
        status: status ? `${t(`children:${status}`)} ${graduated || ''}` : '',
        from: `${klass} ${school}`,
        balance,
        balanceCamp,
        loading,
        hasCafeteria,
        isGlolime,
        isStudent,
        isToday: isToday(state, props),
        lc: personalAccountNumber ? `Л/с: ${personalAccountNumber}` : '',
        externalSystemSync,
      });
    }
  )
);
